import { LoadingIndicator } from '@shared/components/loading';
import styles from './CardListLoading.module.css';

// Stands in for a group's cards until its first page arrives, so an expanded group
// doesn't sit empty between its header rendering and its cards loading
export function CardListLoading() {
  return <LoadingIndicator className={styles.cardListLoading} />;
}
